<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIsoIcTetkik from "@/models/StrIsoIcTetkik";
export default {
  mixins: [Api, Sabit, StrIsoIcTetkik],
  props: ["Tetkikid"],
  data() {
    return {
      TableData: [],
      No: null,
      Soru: null
    };
  },
  components: {
    Loader
  },
  watch: {
    Tetkikid() {
      this.TableGet();
    },
  },
  methods: {
    TableGet() {
      if (this.Tetkikid) {
        var Page = {
          PageNumber: "1",
          PageSize: "9999",
          PageDataSize: "1",
        }
        this.ActionsFilterGet({ Service: "StrIsoIcTetkikSoru", Page: Page, Filter: "&Tetkikid=" + this.Tetkikid }).then((res) => {
          this.TableData = res.Data;
        });
      }
    },
    Get() { this.TableGet() },
    onSubmit() {
      if (this.Soru && this.No) {

        this.Post("StrIsoIcTetkikSoru", {
          Tetkikid: this.Tetkikid,
          No: this.No,
          Soru: this.Soru
        })

      }
    }

  },
};
</script>
<template>
  <Loader>
    <b-modal id="StrIsoIcTetkikSoru" size="lg" title="İÇ TETKİK SORULARI" title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <div class="row">

          <div class="row mb-4">
            <b-form-group class="col-md-5" label="No">
              <b-form-input v-model="No" type="number"></b-form-input>
            </b-form-group> 
            <b-form-group class="col-md-5" label="Soru">
              <b-form-input v-model="Soru"></b-form-input>
            </b-form-group> 
            <button class="btn btn-primary col-md-2 mt-4" style="height: 40px;" type="submit">
              Kaydet
            </button>
          </div>
 
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>Soru No</th>
                  <th>Soru</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in TableData" :key="Data.Id">
                  <th scope="row">{{ Data.No }}</th>
                  <td>{{ Data.Soru }}</td>
                  <td>
                    <div class="action-is w-100 d-flex justify-content-center align-items-center">
                      <i class="fas fa-trash-alt" @click="Delete('StrIsoIcTetkikSoru', Data.Id)"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> 

          
        </div>
      </Form>
    </b-modal>
  </Loader>
</template>
